export default __webpack_public_path__ + "static/media/logoSampark.fdabf425.png";